import { useMutation } from '@tanstack/react-query'

import { verifyMFAEmailCode } from '../services/verify-MFA-email-code.service'

export function useVerifyMFAEmailCode() {
  return useMutation({
    mutationFn: verifyMFAEmailCode,
  })
}
